var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReactionLaughing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    fillRule: "evenodd",
    d: "M31.795 15.897c0 8.78-7.118 15.897-15.898 15.897S0 24.677 0 15.897C0 7.117 7.117 0 15.897 0c8.78 0 15.898 7.117 15.898 15.897",
    transform: "translate(-147 -1271) translate(39 1271) translate(108)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E3742",
    d: "M7.17 12.85s5.713-.672 7.226-.672c0 0-.337-2.688-4.201-3.193l1.848 1.68s-3.697.169-4.874 2.185M27.503 12.85s-5.714-.672-7.226-.672c0 0 .336-2.688 4.2-3.193l-1.848 1.68s3.697.169 4.874 2.185M6.33 17.724s11.594-2.017 21.341 0c0 0-.505 9.72-10.587 9.914-8.738.168-10.755-9.914-10.755-9.914",
    transform: "translate(-147 -1271) translate(39 1271) translate(108)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.86 17.956c.11.38.9 2.456 5.023 2.456 4.537 0 9.074.168 11.427 0 1.407-.1 2.03-1.34 2.305-2.324-7.2-1.335-15.209-.588-18.755-.132",
    transform: "translate(-147 -1271) translate(39 1271) translate(108)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FA5F5F",
    d: "M20.067 26.737c-.092-2.276-2.615-4.103-5.722-4.103-1.722 0-3.263.562-4.313 1.45 1.632 1.72 3.947 3.07 7.188 3.008 1.052-.02 1.993-.149 2.847-.355",
    transform: "translate(-147 -1271) translate(39 1271) translate(108)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactionLaughing);
export default __webpack_public_path__ + "static/media/reactionLaughing.8dd97532.svg";
export { ForwardRef as ReactComponent };